<template>
  <span
    style="cursor: pointer"
    v-single-click="submit"
  >
    {{ isMultipleDelete ? `${ids.length}件を` : '' }}削除
  </span>
</template>

<script lang="ts">
function isDeleteCancelled(error: unknown): boolean {
  const e = error as { isCancel?: boolean; message?: unknown }
  return e?.isCancel === true || String(e?.message || '') === '削除をキャンセルしました'
}

export default {
  name: 'DeleteLink',
  props: {
    modelName: { required: true },
    id: { required: true },
    url: {},
    modalId: { required: false },
  },
  data() {
    return {
      model: {},
    }
  },
  computed: {
    ids() {
      return typeof this.id !== 'object' ? [this.id] : this.id
    },
    isMultipleDelete() {
      return this.ids.length > 1
    },
  },
  methods: {
    async submit() {
      const skipDefaultConfirm =
        $core.$models?.[this.modelName]?.skipDefaultDeleteConfirm === true
      if (
        !skipDefaultConfirm &&
        !(await $core.$toast.confirmDialog('削除します、よろしいですか？', {
          okVariant: 'danger',
          okTitle: '削除する',
        }))
      ) {
        return
      }
      if (!skipDefaultConfirm) {
        $core.$loading.start('削除しています。', 'overlay')
      }
      try {
        // 削除リクエスト
        await $core.$storeMethods.bulkDelete({
          collectionName: this.modelName,
          docIds: this.ids,
          skipConfirm: true,
        })
        this.$emit('deleteCallback', { value: this.id })
        if (this.modalId) {
          $core.$modals.closeModal(this.modalId)
        }
      } catch (e) {
        if (isDeleteCancelled(e)) {
          return
        }
        $core.$toast.errorToast(`削除に失敗しました。${JSON.stringify(e?.message)}`)
        console.error(
          `[/front_nuxt/components/ModelForm.vue] Error: `,
          JSON.stringify(e),
        )
        throw e
      } finally {
        $core.$loading.finish()
      }
    },
  },
}
</script>
